module.exports = __webpack_public_path__ + "img/food-img-3.0a5fcd60.png";